import { Component } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { FormgenFieldControlBComponent } from '../field-control/formgen-field-control.bcomponent';

@Component({
  selector: 'app-formgen-field-checkbox',
  templateUrl: './formgen-field-checkbox.component.html',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class FormgenFieldCheckboxComponent extends FormgenFieldControlBComponent {
  onChange($event) {
    this.callEvent('onChange', $event);
  }
}
